import React from 'react';
import ReactDOM from 'react-dom';

import { driver } from "driver.js";
import "driver.js/dist/driver.css";

import { ProgressStore } from './progress';
import supportFunctions from './support';

import { TourMenu } from './components/TourMenu';


export const initTours = () => {
  if (typeof(window.fc_tours) === 'undefined') {
    return;
  }

  const progressStore = new ProgressStore();

  const startTour = (tourID, currentStep=0) => {
    const tour = window.fc_tours[tourID];

    if (!tour) {
      return;
    }

    const driverObj = driver({
      ...tour,
      onNextClick: (element, step, options) => {
        progressStore.setCurrentStep(tourID, options.index + 1);
        driverObj.moveNext();
      },
      onDestroyed: () => {
        // Regardless of whether the user has completed the tour, or if
        // they've cancelled it halfway through, let's not show it again.
        progressStore.setCompleted(tourID);
        if (tour.onDestroyFunc && supportFunctions[tour.onDestroyFunc]) {
          supportFunctions[tour.onDestroyFunc]();
        }
      }
    });

    if (tour.beforeStartFunc && supportFunctions[tour.beforeStartFunc]) {
      const shouldStart = supportFunctions[tour.beforeStartFunc](driverObj, progressStore.get(tourID));
      if (!shouldStart) {
        return;
      }
    }

    driverObj.drive(currentStep);
    progressStore.setStarted(tourID);
  }

  Object.entries(window.fc_tours).forEach(
    ([tourID, tour], idx) => {

      const progress = progressStore.get(tourID);

      if (!progress.completed && (tour.autostart || progress.currentStep)) {
        startTour(tourID, progress.currentStep);
      }
    }
  );

  const tourMenuElem = document.getElementById('tour-menu');
  if (tourMenuElem && Object.keys(window.fc_tours).length > 0) {
    ReactDOM.render(
      <TourMenu
        onSelectTour={startTour}
        tours={window.fc_tours}
      />,
      tourMenuElem
    );
  }
}
